import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Matchup from './pages/Matchup';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/matchup"       element={<Matchup />} />
      </Routes>
    </BrowserRouter>
  );
}
